import { render, staticRenderFns } from "./rightBottom.vue?vue&type=template&id=6fb8e180"
import script from "./rightBottom.vue?vue&type=script&lang=js"
export * from "./rightBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports